import { render, staticRenderFns } from "./measurement.vue?vue&type=template&id=85911d5a&scoped=true&"
import script from "./measurement.vue?vue&type=script&lang=js&"
export * from "./measurement.vue?vue&type=script&lang=js&"
import style0 from "./measurement.vue?vue&type=style&index=0&id=85911d5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85911d5a",
  null
  
)

export default component.exports